<footer class="footer py-3 bg-body-tertiary border-top">
  <div class="container-fluid d-flex justify-content-between align-items-center">
    <div class="text-body-secondary">
      &copy; Bizerba – 2025
    </div>
    <div>
      <a href="https://forms.office.com/e/PHZjB2EN1K" class="btn btn-outline-primary btn-sm" target="_blank" rel="noopener noreferrer">
        Give us Feedback
      </a>
    </div>
  </div>
</footer>
